import { render, staticRenderFns } from "./What.vue?vue&type=template&id=040dbf10&"
import script from "./What.vue?vue&type=script&lang=js&"
export * from "./What.vue?vue&type=script&lang=js&"
import style0 from "./What.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports